module.exports = __webpack_public_path__ + "media/images/levelup_crown_black-5ba898c752780d0c8d98bec4a9039bce.png";